import React from 'react'

function ToggleCheckbox({label, value, setValue, className, onOff=false}) {
    const handleChange = (event) => {
        const checked = event.target.checked;
        // console.log(checked)
        setValue(checked)
    }
    return (
        <div>
            <label className="inline-flex items-center cursor-pointer">
                <input type="checkbox"  checked={value === true} onChange={handleChange} className="sr-only peer"></input>
                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 flex items-center justify-end peer-checked:justify-start px-1">
                    {onOff&&<>
                    <span className={value === true?'text-[0.65rem] text-white select-none':'text-[0.65rem] text-gray-500 select-none'}>{value === true?'On':'Off'}</span>
                    </>}
                </div>
                <span className={`ms-3 text-sm font-medium text-gray-900 dark:text-gray-300 ${className}`}>{label}</span>
            </label>
        </div>
    )
}

export default ToggleCheckbox